import React, { useEffect, useState } from "react";
import { AppBar, Typography, Box, CircularProgress } from "@mui/material";

interface DocumentViewerProps {
  fileName: string;
  title: string;
}

const DocumentViewer: React.FC<DocumentViewerProps> = ({ fileName, title }) => {
  const [htmlContent, setHtmlContent] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    document.title = title;

    const fetchDoc = async () => {
      try {
        setLoading(true);
        const response = await fetch(`/documents/${fileName}`);
        if (!response.ok) {
          throw new Error(`Failed to load document: ${response.statusText}`);
        }
        const text = await response.text();
        setHtmlContent(text);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDoc();
  }, [fileName, title]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={4}>
        <Typography color="error">Error: {error}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ bgcolor: "#fff", minHeight: "100vh" }}>
      <AppBar
        color="transparent"
        position="static"
        sx={{ padding: "10px 20px" }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          KUIKWIT
        </Typography>
      </AppBar>
      <Box sx={{ maxWidth: "1280px", margin: "0 auto", padding: "20px" }}>
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      </Box>
    </Box>
  );
};

export default DocumentViewer;
